// 列表组件需要的数据
export const OPTHINES = {
  voteName: '2019poject/2019xljyacs',
  mustSearch: 'Button',
  number: {
    mustRank: false,
  },
  listData: {
    type: 'com',
  },
  name: true,
  content: true,
  user: true,
  tickets: {
    textFirst: '赞数',
    textLast: '赞',
  },
  checkBox: false,
  hasVoteButton: {
    text: '点赞',
    textColor: '#fff',
    themeColor: '#fe4d57',
  },
  themeColor: {
    activeBgColor: '#fe4d57',
    inactiveBgColor: '#f1f1f1',
  },
};
